import { pathOr } from 'ramda';

import { IVideoSchema } from '../../repositories/offer-card/entities/video/VideoSchema';
import { IState } from '../../store';

export const getVideos = (state: IState): IVideoSchema[] => {
  return pathOr([], ['offerData', 'offer', 'videos'], state);
};
